import { fromJS, Map } from 'immutable';
import Actions from 'flow/actions';

const initialState = Map();

export const ringtoneReducer = (state = initialState, action) => {
    switch (action ? action.type : null) {
        case Actions.CLEAR_STATE: {
            return initialState;
        }
        case Actions.RESULT_RINGTONE_SETTINGS: {
            return state.set('settings', fromJS(action.data));
        }
        case Actions.RESULT_RINGTONES_LIST: {
            return state.set('all', fromJS(action.data));
        }
        default: {
            return state;
        }
    }
};

export default ringtoneReducer;
